import { gql } from '@apollo/client'

export const EDIT_COMPANY_MEMBER = gql`
  mutation EditCompanyMember($inputData: EditCompanyMemberInput!) {
    editCompanyMember(inputData: $inputData) {
      id
    }
  }
`
